import TimeUtil from 'utils/time-util'
import PropTypes from 'prop-types'
import { Button } from 'reactstrap'
import { MarketingDiscountBatchStatusBadge } from 'domains/marketing-discount-batch/badges'

const propTypes = {
  discountBatch : PropTypes.object,
  handleClick   : PropTypes.func
}

const defaultProps = {
  discountBatch : {},
  handleClick   : () => {}
}

const MarketingDiscountBatchTableRow = ({
  discountBatch,
  handleClick
}) => {
  const start_date   = TimeUtil.format(discountBatch.start_batch_job_at, 'DD MMM YYYY HH:mm:ss')
  const expired_date = TimeUtil.format(discountBatch.expire_batch_job_at, 'DD MMM YYYY HH:mm:ss')

  return (
    <tr>
      <td>{ discountBatch.code }</td>
      <td>{ start_date }</td>
      <td>{ expired_date }</td>
      <td><MarketingDiscountBatchStatusBadge status={ discountBatch.status }/></td>
      <td className="d-flex flex-column bd-highlight mb-3">
        <Button
          size='sm'
          color='info'
          className= 'align-self-center'
          onClick={ () => handleClick(discountBatch.id) }
        >
          { 'View' }
        </Button>
      </td>
    </tr>
  )
}

MarketingDiscountBatchTableRow.propTypes    = propTypes
MarketingDiscountBatchTableRow.defaultProps = defaultProps


export default MarketingDiscountBatchTableRow